import { lazy } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import MainLayout from "./layouts/main-layout";
import PrivateRoute from "./private-route";

const ReportsMainPage = lazy(() => import("../modules/Reports"));

const MainRoute = () => (
  <PrivateRoute>
    <MainLayout>
      <Outlet />
    </MainLayout>
  </PrivateRoute>
);

const ReportsRoutes = (
  <Route path="/reports" element={<MainRoute />}>
    <Route path="clinical-reports/:reportType" element={<ReportsMainPage />}>
      <Route
        index
        element={
          <Navigate to="reports/clinical-reports/appointment-report" replace />
        }
      />
    </Route>
    <Route path="billing-reports/:reportType" element={<ReportsMainPage />}>
      <Route
        index
        element={<Navigate to="reports/billing-reports/churn-report" replace />}
      />
    </Route>
  </Route>
);

export default ReportsRoutes;
